import { Component } from '@angular/core';

import { BtnActionComponent } from '../btn-action/btn-action.component';

@Component({
    selector: 'aa-btn-action-secondary',
    templateUrl: '../btn-action/btn-action.component.html',
    styleUrls: [
        '../btn-action/btn-action.component.scss',
        './btn-action-secondary.component.scss'
    ],
    standalone: false
})
export class BtnActionSecondaryComponent extends BtnActionComponent
{
    constructor ()
    {
        super();
    }
}
